import React, { useState, useEffect } from 'react';

function MindfulnessZone() {
  const [isActive, setIsActive] = useState(false);
  const [phase, setPhase] = useState('Ready?'); // Inhale, Hold, Exhale
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let interval;
    if (isActive) {
      interval = setInterval(() => {
        setTimer((prev) => {
          const newTime = prev + 1;
          // 4 seconds Inhale, 4 seconds Hold, 4 seconds Exhale
          if (newTime <= 4) setPhase('Breathe In...');
          else if (newTime <= 8) setPhase('Hold...');
          else if (newTime <= 12) setPhase('Breathe Out...');
          else return 1; // Reset cycle
          return newTime;
        });
      }, 1000);
    } else {
      setPhase('Ready?');
      setTimer(0);
    }
    return () => clearInterval(interval);
  }, [isActive]);

  // Dynamic style based on phase
  let circleScale = 'scale-100';
  if (phase === 'Breathe In...') circleScale = 'scale-150 bg-ocean-teal/30';
  else if (phase === 'Hold...') circleScale = 'scale-150 bg-ocean-teal/50';
  else if (phase === 'Breathe Out...') circleScale = 'scale-100 bg-ocean-teal/10';

  return (
    <section className="py-24 px-6 md:px-16 lg:px-24 bg-deep-charcoal text-white relative overflow-hidden">
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal bg-white/10 px-4 py-2 rounded-full">Interactive Therapy Tool</span>
        <h2 className="text-4xl md:text-5xl font-serif font-bold mt-8 mb-6">The Mindfulness Zone</h2>
        <p className="text-white/70 mb-16 max-w-xl mx-auto">
          Feeling overwhelmed? Take a moment to ground yourself with this guided 4-4-4 breathing exercise. Press start and follow the circle.
        </p>

        {/* The Interactive Game Area */}
        <div className="relative w-64 h-64 mx-auto flex items-center justify-center mb-12">
          {/* Animated Circle */}
          <div className={`absolute inset-0 rounded-full transition-all duration-[4000ms] ease-in-out ${isActive ? circleScale : 'scale-100 bg-white/5'}`}></div>
          
          {/* Center Content */}
          <div className="relative z-10 flex flex-col items-center">
            <h3 className="text-2xl font-serif font-bold mb-4 transition-all">{phase}</h3>
            {isActive && <span className="text-4xl font-light">{timer % 4 === 0 ? 4 : timer % 4}</span>}
          </div>
        </div>

        <button 
          onClick={() => setIsActive(!isActive)}
          className={`px-10 py-4 rounded-full font-black uppercase tracking-widest text-xs transition-all ${isActive ? 'bg-red-500/20 text-red-400 hover:bg-red-500/30 border border-red-500/30' : 'bg-ocean-teal text-white hover:bg-ocean-teal/90 shadow-xl shadow-ocean-teal/20'}`}
        >
          {isActive ? 'Stop Exercise' : 'Start Breathing'}
        </button>
      </div>
      
      {/* Background decorations */}
      <div className="absolute top-[-20%] left-[-10%] w-96 h-96 bg-ocean-teal opacity-10 rounded-full blur-3xl pointer-events-none"></div>
    </section>
  );
}

export default MindfulnessZone;